'use client';

/**
 * Fires a formVisible event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireFormVisibleEvent } = useFormVisibleEvent();
 * fireFormVisibleEvent({
 *    formName: 'search',
 *    formContent: searchValue,
 *    formContent2: displayName,
 * });
 * @param {Object} values - values to use for the event
 * @param {string} values.formContent - information about a form e.g. searched term, Product of interest, non PII field inputs
 * @param {string} values.formContent2 - information about a form e.g. searched term, Product of interest, non PII field inputs
 * @param {string} values.formFieldCausingError -  If the form opening was prevented by a field / fields that were not properly filled out, pass the names of those fields here. On successful form submits, pass empty string. e.g. email, phone number
 * @param {string} values.formLocation - Form location on the page (where on the page not which page, only in cases there are multiple instances of the form on a page). e.g. CATRetail_HPEspotTop
 * @param {string} values.formName - Name of the visible form. e.g. Contact Us
 * @param {string} values.pagePath -  Page on which the formVisible data layer push occurred. e.g. /en/search/search-results.html
 * @param {string} values.formStatus - Was the form opening a success or fail including details about the fail, if applicable. e.g. success, fail
 */

import { sendGTMEvent } from '@next/third-parties/google';
import {
  EVENT_FORM_VISIBLE,
  STATUS_SUCCESS
} from 'constants/analyticsConstants';
import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

export const useFormVisibleEvent = () => {
  /*  TODO - Input Validations - usePathName: Validate pathname is a valid
  string with alphanumeric values allowin only two special characters . Slash (/)
  and Dash (-) . UNDER INVESTIGATION - All valid part number characters*/
  const pathname = usePathname();
  const buildEvent = useCallback(
    ({
      formContent = '',
      formContent2 = '',
      formFieldCausingError = '',
      formLocation = '',
      formName = '',
      pagePath = pathname,
      formStatus = STATUS_SUCCESS
    }) => ({
      event: EVENT_FORM_VISIBLE,
      formFieldCausingError,
      formName,
      formContent,
      formContent2,
      formStatus,
      formLocation,
      pagePath
    }),
    [pathname]
  );
  const fireFormVisibleEvent = useCallback(
    (values) => {
      const event = buildEvent(values);
      sendGTMEvent(event);
    },
    [buildEvent]
  );
  return { fireFormVisibleEvent };
};
